import { TModule } from '../types';

/**
 * Check if the module is already loaded in the window object.
 * @param moduleConfig
 */
export const doesModuleAlreadyExist = (moduleConfig: TModule): boolean => {
    return moduleConfig.boundName in window;
};
